import { type SelectGroup, type SelectItem } from '@fastnorth/kraken/components/select';
import type { SubEvent } from '../../../types/events.ts';
import { useMemo } from 'react';

export type RaceSelectItem = { itemLabel: string; value: string; sortOrder?: number };

type AsRacesSelectListOptions = {
  sortCompare?: (a: RaceSelectItem, b: RaceSelectItem) => number;
  prependItems?: SelectItem[];
};

const useRaceSelectList = (
  races: SubEvent[],
  options: AsRacesSelectListOptions = {}
): SelectGroup[] => {
  const { sortCompare } = options;

  const filteredItems = useMemo(
    () =>
      races
        .map<RaceSelectItem>((race) => ({
          itemLabel: `${race.name}`,
          value: `${race.id}`,
          sortOrder: race?.sortOrder,
        }))
        .filter(({ value }) => !!value),
    [races]
  );

  const raceItems = options.prependItems
    ? [...options.prependItems, ...filteredItems]
    : filteredItems;

  if (sortCompare) {
    raceItems.sort(sortCompare);
  }

  const items: RaceSelectItem[] = [...raceItems];

  return [
    {
      items,
    },
  ];
};

export default useRaceSelectList;
